module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-35.79eb4b91.png";